import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Send, FlaskConical, Loader2 } from "lucide-react";
import { adminApi, fmtDate } from "./adminApi";
import { ARTICLES } from "@/content/articles";

const SITE = "https://centrodiparodontologia.com";
const EMPTY = { subject: "", body: "", link_url: "", link_label: "" };
const inputCls = "w-full rounded-2xl border border-[#1B3B28]/15 bg-[#FCFBF7] px-4 py-3 text-[15px] text-[#1E2922] outline-none focus:border-[#3E6B48]";

export const NewsletterTab = () => {
  const [stats, setStats] = useState(null);
  const [c, setC] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const load = () => adminApi.get("/admin/newsletter").then(({ data }) => setStats(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const fromArticle = (slug) => {
    const a = ARTICLES.find((x) => x.slug === slug);
    if (a) setC({ subject: a.title, body: `${a.intro}\n\nNel nuovo articolo del blog trovi tutti i consigli del Dott. Nicola Mauro.`, link_url: `${SITE}/blog/${a.slug}`, link_label: "Leggi l'articolo" });
  };
  const send = async (test) => {
    const active = stats?.counts?.attivo ?? 0;
    if (!test && !window.confirm(`Inviare la newsletter a ${active} iscritti?`)) return;
    setBusy(true);
    try {
      const { data } = await adminApi.post("/admin/newsletter/send", { ...c, test });
      toast.success(test ? `Email di prova inviata a ${data.to}` : `Invio avviato a ${data.recipients} iscritti`);
      if (!test) { setC(EMPTY); load(); }
    } catch (e) { toast.error(typeof e.response?.data?.detail === "string" ? e.response.data.detail : "Controlla oggetto e testo (minimo 10 caratteri)"); }
    finally { setBusy(false); }
  };

  const n = stats?.counts ?? {};
  return (
    <div className="grid lg:grid-cols-12 gap-8" data-testid="newsletter-tab">
      <div className="lg:col-span-7 rounded-3xl bg-[#FCFBF7] border border-[#1B3B28]/10 p-6 space-y-4">
        <p className="f-serif text-3xl text-[#1B3B28]">Scrivi la newsletter</p>
        <select onChange={(e) => fromArticle(e.target.value)} defaultValue="" className={inputCls} data-testid="newsletter-article-select">
          <option value="" disabled>Parti da un articolo del blog (facoltativo)</option>
          {ARTICLES.map((a) => <option key={a.slug} value={a.slug}>{a.title}</option>)}
        </select>
        <input value={c.subject} onChange={(e) => setC({ ...c, subject: e.target.value })} placeholder="Oggetto" maxLength={140} className={inputCls} data-testid="newsletter-subject-input" />
        <textarea value={c.body} onChange={(e) => setC({ ...c, body: e.target.value })} rows={9} placeholder="Testo (lascia una riga vuota tra i paragrafi)" className={`${inputCls} resize-y`} data-testid="newsletter-body-input" />
        <div className="grid sm:grid-cols-2 gap-3">
          <input value={c.link_url} onChange={(e) => setC({ ...c, link_url: e.target.value })} placeholder="Link pulsante (https://...)" className={inputCls} data-testid="newsletter-link-input" />
          <input value={c.link_label} onChange={(e) => setC({ ...c, link_label: e.target.value })} placeholder="Testo pulsante" maxLength={60} className={inputCls} data-testid="newsletter-link-label-input" />
        </div>
        <div className="flex flex-wrap gap-2 pt-2">
          <button onClick={() => send(true)} disabled={busy} data-testid="newsletter-test-btn" className="inline-flex items-center gap-2 rounded-full border border-[#1B3B28]/20 px-5 py-2.5 text-sm text-[#1B3B28] hover:bg-[#E6ECE4] disabled:opacity-60"><FlaskConical size={15} /> Invia una prova a me</button>
          <button onClick={() => send(false)} disabled={busy || !n.attivo} data-testid="newsletter-send-btn" className="inline-flex items-center gap-2 rounded-full bg-[#1B3B28] text-[#FCFBF7] px-5 py-2.5 text-sm hover:bg-[#3E6B48] disabled:opacity-50">{busy ? <Loader2 size={15} className="animate-spin" /> : <Send size={15} />} Invia a tutti gli iscritti</button>
        </div>
      </div>
      <div className="lg:col-span-5 space-y-4">
        <div className="rounded-3xl bg-[#1B3B28] text-[#FCFBF7] p-6" data-testid="newsletter-stats">
          <p className="f-serif text-6xl leading-none">{n.attivo ?? 0}</p>
          <p className="text-sm text-[#FCFBF7]/75 mt-2">iscritti attivi · {n.in_attesa ?? 0} in attesa di conferma · {n.disiscritto ?? 0} disiscritti</p>
        </div>
        <div className="rounded-3xl bg-[#FCFBF7] border border-[#1B3B28]/10 p-6">
          <p className="eyebrow text-[#3E6B48]">Ultimi invii</p>
          <ul className="mt-3 space-y-2 text-sm">
            {(stats?.campaigns ?? []).map((x, i) => <li key={i} className="flex justify-between gap-3"><span className="text-[#1B3B28]">{x.subject}</span><span className="text-[#526356] shrink-0">{fmtDate(x.sent_at)} · {x.sent ?? x.recipients}</span></li>)}
            {!stats?.campaigns?.length && <li className="text-[#526356]">Nessun invio finora.</li>}
          </ul>
        </div>
        <p className="text-xs text-[#526356]">Si iscrive solo chi lo chiede dal sito e conferma via email (doppio consenso, GDPR). Ogni email contiene il link per disiscriversi.</p>
      </div>
    </div>
  );
};
